<template>
  <div>
    <div class="form-group">
      <label>Name</label>
      <input type="text" v-model.trim="form.name" class="form-control">
      <div class="text-danger" v-if="errors.name">{{ errors.name[0] }}</div>
    </div>  

    <div class="form-group">
      <label>Type</label>
      <select :disabled="disabledChangeType" v-model="form.type" class="form-control">
        <option value="parking">Parking</option>
        <option value="room">Room</option>
      </select>
      <div class="text-danger" v-if="errors.type">{{ errors.type[0] }}</div>
    </div>

    <div class="form-group">
      <label>Attribute Definitions</label>
      <p class="help-block">Attribute keys and labels are free text. The key is sent to the integration; the label is shown on the location form.</p>
      <div v-for="(attribute, index) in form.attributes" :key="index" class="row margin-bottom-1x">
        <div class="col-sm-4">
          <label>Key</label>
          <input type="text" v-model.trim="attribute.key" class="form-control">
          <div class="text-danger" v-if="errors['attributes.' + index + '.key']">
            {{ errors['attributes.' + index + '.key'][0] }}
          </div>
        </div>
        <div class="col-sm-4">
          <label>Label</label>
          <input type="text" v-model.trim="attribute.label" class="form-control">
          <div class="text-danger" v-if="errors['attributes.' + index + '.label']">
            {{ errors['attributes.' + index + '.label'][0] }}
          </div>
        </div>
        <div class="col-sm-3">
          <label>Default value</label>
          <input type="text" v-model.trim="attribute.default_value" class="form-control">
          <div class="text-danger" v-if="errors['attributes.' + index + '.default_value']">
            {{ errors['attributes.' + index + '.default_value'][0] }}
          </div>
        </div>
        <div class="col-sm-1">
          <label>&nbsp;</label>
          <div>
            <a class="text-danger" href="#" @click.prevent="removeAttribute(index)">
              <i class="fa fa-trash fa-lg"></i>
            </a>
          </div>
        </div>
      </div>
      <button class="btn btn-default btn-sm" @click.prevent="addAttribute">
        <i class="fa fa-plus"></i>
        Add Attribute
      </button>
      <div class="text-danger" v-if="errors.attributes">{{ errors.attributes[0] }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'integration-system-form-fields',
  props: {
    form: {
      type: Object,
      required: true
    },
    errors: {
      type: Object,
      default: () => ({})
    },
    disabledChangeType: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    addAttribute () {
      this.form.attributes.push({key: '', label: ''})
    },
    removeAttribute (index) {
      this.form.attributes.splice(index, 1)
    }
  }
}
</script>
